import React, { useState, useEffect } from "react";
import { Button } from "../../../../styled-components/button";
import * as Style from "./styles/static-return-rate";
import { InputGroup } from "../../../../styled-components/input/styles/input";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import { Text } from "../../../../styled-components/text";
import IconInputTax from "../../../../styled-components/input/icon-input-tax";
import UserDefined from "../user-defined/user-defined";
import { setSelectedStaticRateofReturn } from "../../../../../redux/slices/inventorySlice";
import { useSelector, useDispatch } from "react-redux";

function StaticReturnRate({
  handleRatesOfReturnObject,
  nextForm,
  data,
  rateOfReturnData,
}) {
  const { styles } = defaultStyles;
  const dispatch = useDispatch();

  const uniqueKey = Object.keys(data.staticReturnRate.data)[0];
  const staticReturnRateObj = data.staticReturnRate.data[uniqueKey];
  const staticRateofReturnValue = useSelector(
    (state) => state.rootReducer.inventory.selectedStaticRateofReturn
  );

  const [staticReturnRateData, setStaticReturnRateData] = useState({
    Static: rateOfReturnData && rateOfReturnData.staticPercentage,
  });
  console.log("staticRateofReturnValue", staticRateofReturnValue);

  const handleStaticReturnRateInfo = (obj) => {
    const { name, value } = obj;

    setStaticReturnRateData({
      ...staticReturnRateData,
      [name]: value,
    });
    dispatch(setSelectedStaticRateofReturn(value));
  };
  useEffect(() => {
    if (rateOfReturnData) {
      console.log("rateOfReturnData", rateOfReturnData);
      if (staticRateofReturnValue) {
        setStaticReturnRateData({
          Static: staticRateofReturnValue,
        });
      } else {
        setStaticReturnRateData({
          Static: rateOfReturnData && rateOfReturnData.staticPercentage,
        });
      }
    }
  }, [rateOfReturnData]);

  const nextComponent = {
    name: "userDefined",
    title: "User Defined",
    isMulti: false,
    component: UserDefined,
  };

  const submitData = () => {
    handleRatesOfReturnObject(staticReturnRateData);

    nextForm(nextComponent);
  };

  const fields = [
    {
      Component: IconInputTax,
      value: {
        name: "Static",
        title: "Static Percentage",
        icon: "%",
        iconPosition: "end",
        value: staticReturnRateData["Static"],
        onChange: (event) => handleStaticReturnRateInfo(event.target),
      },
    },
  ];

  return (
    <Style.MainContainer style={{ backgroundColor: "#ffffff", margin: "16px" }}>
      <h2
        style={{
          fontSize: "28px",
          fontWeight: "600",
          color: "#2A3DA3",
          margin: "0",
        }}
      >
        Static Rate of Return
      </h2>

      <Style.FieldsContainer>
        {fields &&
          fields.map((data, index) => {
            const { value, Component } = data;
            return (
              <InputGroup style={{ width: "30%" }}>
                <Text
                  style={styles.text.labelBoldText}
                  padding="2rem 0 1rem 0 "
                >
                  {value.title}
                </Text>

                <Component key={index} value={value} />
              </InputGroup>
            );
          })}
      </Style.FieldsContainer>

      <Style.ButtonContainer>
        <Button onClick={submitData}>Next</Button>
      </Style.ButtonContainer>
    </Style.MainContainer>
  );
}

export default StaticReturnRate;
